import { apiClient } from "helpers/api_helper";

export const GetOgPurchesReport = async (query: {
  StoreId?: string;
  fromDate?: string;
  toDate?: string;
}) => {
  try {
    const params = new URLSearchParams();

    if (query.StoreId && query.StoreId.trim() !== "") {
      params.append("StoreId", query.StoreId);
    }
    if (query.fromDate && query.fromDate.trim() !== "") {
      params.append("fromDate", query.fromDate);
    }
    if (query.toDate && query.toDate.trim() !== "") {
      params.append("toDate", query.toDate);
    }

    const url = `/api/v1/Report/GetPurchseOrderItemStokDetails${
      params.toString() ? `?${params.toString()}` : ""
    }`;

    const response = await apiClient.get(url);
    return response;
  } catch (error: any) {
    throw new Error(error.message);
  }
};
